import type React from 'react';

import { toJS } from 'mobx';
import { observer } from 'mobx-react';

import { useCustomListStore } from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';

import Button from 'bz-core-controls/controls/general/button';
import {
  useMenuPageItem,
  useMenuStore
} from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import { useBzPopoverStore } from 'bz-stores/mobx/popover-store';

import { useAction } from 'bz-utilities/hooks/action';

import type OptionsDetailsStore from '../../store/option-details';

export interface IProps {
  details: OptionsDetailsStore;
}

const OptionsDetailsSave: React.FC<IProps> = observer(({ details }) => {
  const { close } = useBzPopoverStore();
  const item = useMenuPageItem();
  const menu = useMenuStore();
  const store = useCustomListStore();

  const save = useAction((): void => {
    item.description = details.description;
    item.alternates.replace(toJS(details.alts));
    store.onApply(menu!.onExtract());

    close();
  }, [close, details, item, store]);

  return <Button className="save col-span-2" small={true} label="Save" onClick={save} />;
});

OptionsDetailsSave.displayName = 'OptionsDetailsSave';

export default OptionsDetailsSave;
